import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=7a96677d&scoped=true&"
import script from "./SideNav.vue?vue&type=script&lang=ts&"
export * from "./SideNav.vue?vue&type=script&lang=ts&"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=7a96677d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a96677d",
  null
  
)

export default component.exports